import { toValue, type MaybeRefOrGetter } from 'vue'
import { useStorage } from '@vueuse/core'

export function useLocalStorage<T>(key: string, defaults: MaybeRefOrGetter<T>) {
  try {
    return useStorage<T>(key, defaults, localStorage, {
      serializer: {
        read: (v: string): T => (v ? (JSON.parse(v) as T) : toValue(defaults)),
        write: (v: T) => JSON.stringify(v)
      }
    })
  } catch (error) {
    throw new Error(`Error initializing localStorage: ${error}`, {
      cause: error
    })
  }
}
